import { TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateCategoryAction,
  createCategoryAction,
  deleteCategoryAction,
  getAllCategoryAction,
} from "../../../redux/actions/CarAction";

const Addcategory = () => {
  const [Name, setName] = useState("");
  const [IDcat, setIDcat] = useState("");
  const [IsEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPres, setisPres] = useState(false);

  const dispatch = useDispatch();
  const [Deletesow, setDeletesow] = useState(false);
  const handleCloseDelete = () => setDeletesow(false);
  const handleShowDelete = (item) => {
    setDeletesow(true);
    setIDcat(item.id);
  };
  useEffect(() => {
    dispatch(getAllCategoryAction());
  }, []);
  const AllCat = useSelector((state) => state.CarReduser.GetAllCategory);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Name === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPres(true);
    await dispatch(
      createCategoryAction({
        name: Name,
      })
    );
    setName("");
    setLoading(false);
    setisPres(false);
  };
  const handlesubmitUpdate = async (e) => {
    e.preventDefault();
    if (Name === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPres(true);

    await dispatch(
      UpdateCategoryAction({
        category_name: Name,
        category_id: IDcat,
      })
    );
    setName("");
    setLoading(false);
    setisPres(false);
    setIsEdit(false);
    setIDcat("");
  };
  const update = (item) => {
    setIsEdit(true);
    setIDcat(item.id);
    setName(item.name);
  };
  const handleDelete = async () => {
    setisPres(true);

    await dispatch(
      deleteCategoryAction({
        category_id: IDcat,
      })
    );
    setDeletesow(false);
    setLoading(false);
    setisPres(false);
    setIDcat("");
  };
  const res = useSelector((state) => state.CarReduser.createCategory);
  const UP = useSelector((state) => state.CarReduser.updateCategory);
  const DEL = useSelector((state) => state.CarReduser.deleteCategory);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1000);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");

            dispatch(getAllCategoryAction());
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
            dispatch(getAllCategoryAction());
          } else {
            notify("هناك مشكلة حاول مرة اخرى", "error");
          }
        }
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (UP.data) {
            notify(UP.data.message, "success");
            dispatch(getAllCategoryAction());
          } else if (UP.status !== 200) {
            UP.data.message.map((message) => notify(message, "error"));
            dispatch(getAllCategoryAction());
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          if (UP.data) {
            notify(UP.data.message, "error");
            dispatch(getAllCategoryAction());
          } else {
            notify("هناك مشكلة حاول مرة اخرى", "error");
            dispatch(getAllCategoryAction());
          }
        }
      }

      if (DEL) {
        if (DEL.status === 200 || DEL.status === 201) {
          if (DEL.data) {
            notify(DEL.data.message, "success");
            dispatch(getAllCategoryAction());
          }
          // dispatch(getAllCategoryAction());
        } else if (DEL.status !== 200 || DEL.status !== 201) {
          if (DEL.data) {
            DEL.data.message.map((message) => notify(message, "error"));
            dispatch(getAllCategoryAction());
          } else {
            notify("هناك مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div>
      {" "}
      <Container>
        <div className="inputs-container">
          <div className="inp-container m-auto ">
            <TextField
              focused
              label={
                <Typography
                >
               اسم الفئة
                  <span style={{ color: "red", fontSize: "21px" }}>
                    *
                  </span>
                </Typography>
              }
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              value={Name}
            />
          </div>
        </div>
        {loading && isPres ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : IsEdit ? (
          <button className="buttonadd" onClick={handlesubmitUpdate}>
            تعديل
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            إضافة
          </button>
        )}
        <Table className="maint" responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                الأسم <i className="fa-solid fa-user"></i>
              </th>
              <th></th>

              <th></th>
            </tr>
          </thead>
          <tbody>
            {AllCat && AllCat.length >= 0
              ? AllCat.map((item,idx) => (
                  <tr key={idx}>
                    <td>{item.name}</td>
                    <td className="icon-w">
                      <i
                        onClick={() => update(item)}
                        className="fa fa-solid fa-pen-to-square"
                        style={{ color: "rgb(0 44 146)" }}
                      ></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShowDelete(item)}
                        className="fs fa-solid fa-trash-can"
                        style={{ color: "red" }}
                      ></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </Container>
      <Modal
        show={Deletesow}
        onHide={handleCloseDelete}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>هل تريد حذف العنصر</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          {" "}
          <Addcategory />{" "}
        </Modal.Body> */}

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDelete}
          >
            إغلاق
          </Button>
          <Button variant="secondary" className="close" onClick={handleDelete}>
            موافق
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Addcategory;
